import { z } from "zod";
import { deviceEventSchema } from "./deviceEventSchema";
import { deviceLocationSchema } from "./deviceLocationSchema";
import { deviceMeasurementSchema } from "./deviceMeasurementSchema";
import { networkSchema } from "./networkSchema";

export const deviceSubmissionBodySchema = z.strictObject({
  version: z.literal(1).describe("The version of the schema being used"),
  responseVersion: z
    .uint32()
    .min(1)
    .describe("The expected schema version for the response"),
  deviceId: z
    .string()
    .describe("A unique ID for this device, eg the MAC address"),
  firmwareVersion: z
    .string()
    .describe("The firmware version running on the scale"),
  secondsSincePowerOn: z
    .uint32()
    .describe("The number of seconds since power-on"),
  network: networkSchema,
  isManualSend: z
    .boolean()
    .describe(
      "The send was triggered by a person pressing the manual send button",
    ),
  measurements: z
    .array(deviceMeasurementSchema)
    .describe("Array of scale reports"),
  events: z
    .array(deviceEventSchema)
    .optional()
    .describe("Array of events, if any"),
  location: deviceLocationSchema
    .optional()
    .describe(
      "The location of the device at time of transmission, if available",
    ),
});

export type DeviceSubmissionBody = z.infer<typeof deviceSubmissionBodySchema>;
